import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// added for clinics
import "@fortawesome/fontawesome-free/css/all.min.css";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");

// import { createApp } from "vue";
// import App from "./App.vue";
// import store from "./store";
// import router from "./router";
// import "./assets/css/nucleo-icons.css";
// import "./assets/css/nucleo-svg.css";
// import SoftUIDashboard from "./soft-ui-dashboard";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// // Import permission helper
// // import { can } from "@/permissions/permissions";
// import can from "./permissions/permissions";

// const appInstance = createApp(App);

// // ✅ Attach to globalProperties
// appInstance.config.globalProperties.$can = can;

// appInstance.use(store);
// appInstance.use(router);
// appInstance.use(SoftUIDashboard);
// appInstance.mount("#app");
